import { Circle, Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M20.0645 13C18.5918 10.0366 15.5337 8 12 8C8.46631 8 5.40825 10.0366 3.93555 13" vectorEffect="non-scaling-stroke" />
		<Circle cx="12" cy="12.5" r="3" fill="currentColor" vectorEffect="non-scaling-stroke" />
	</SVG>
);
